"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileFormat = void 0;
const enums_1 = require("../enums");
const getFileFormat = (format) => {
    switch (format) {
        case enums_1.VoiceRecordingFormatEnum.WAV:
            return 'wav';
        case enums_1.VoiceRecordingFormatEnum.WAV49:
            return 'WAV';
        case enums_1.VoiceRecordingFormatEnum.GSM:
            return 'gsm';
    }
};
exports.getFileFormat = getFileFormat;
